import React, { useState, useRef } from 'react';
import Webcam from 'react-webcam';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setImageData } from '../redux-toolkit/slices/imageSlice';
import useWindowSize from '../customhooks/useWindowSize'
const CameraPopup = ({ show, handleClose }) => {
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const dispatch = useDispatch();


  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    dispatch(setImageData(imageSrc));
    handleClose();
    
  };
  const size = useWindowSize();

  let modalSize;
  let heightAndWidth;
  if (size.width < 768) {
    modalSize = 'sm'; // Mobile: Small size
    heightAndWidth = 240;
  } else if (size.width >= 768 && size.width < 1400) {
    modalSize = 'lg'; // Tablet: Large size
    heightAndWidth = 360;
  } else {
    modalSize = 'xl'; // Desktop: Extra large size
    heightAndWidth = 480;
  }

  return (
    <>
      
      <Modal show={show} onHide={handleClose} size={modalSize}>
        <Modal.Header closeButton>
          <Modal.Title>Take a Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-center' style={{ maxWidth: '100%' }}>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={heightAndWidth}
              height={heightAndWidth} // Set the height to match the aspect ratio of the webcam
              videoConstraints={{
                width: heightAndWidth,
                height: heightAndWidth,
                facingMode: 'user',
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={capture}>
            Capture
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {imageSrc && (
        <div>
          <h2>Captured Image:</h2>
          <img src={imageSrc} alt="Captured" />
        </div>
      )} */}
    </>
  );
};

export default CameraPopup;

